import { render, staticRenderFns } from "./ManualChatInput.vue?vue&type=template&id=8a6c3cf4&scoped=true"
import script from "./ManualChatInput.vue?vue&type=script&lang=js"
export * from "./ManualChatInput.vue?vue&type=script&lang=js"
import style0 from "./ManualChatInput.vue?vue&type=style&index=0&id=8a6c3cf4&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6c3cf4",
  null
  
)

export default component.exports